import { useNavigate } from 'react-router';
import { SemCadastro } from '../components/SemCadastro.js';
import {
  Aguardar,
  BotaoLink,
  CabecalhoPagina,
  classeTd,
  classeTh,
  Etiqueta,
  EstadoVazio,
  Tabela,
} from '../components/ui/index.js';
import { formatarData, ROTULO_COMPARTILHAMENTO } from '../dados/catalogo.js';
import { useConsulta, useFonte, usePodeCadastrar } from '../dados/contexto.js';

/** Haras cadastrados. Escolher um define o haras de trabalho e abre o plantel. */
export function ListaHaras() {
  const fonte = useFonte();
  const equipe = usePodeCadastrar();
  const navegar = useNavigate();
  const consulta = useConsulta(
    async (f) => {
      const [haras, animais, avaliacoes, atual] = await Promise.all([
        f.listarHaras(),
        f.listarAnimais(),
        f.avaliacoes(),
        f.haras(),
      ]);
      return { haras, animais, avaliacoes, atual };
    },
    [],
  );

  if (!fonte.cadastro) return <SemCadastro demo={fonte.ficticia} />;

  const escolher = (id: string) => {
    fonte.cadastro!.escolherHaras(id);
    navegar('/animais');
  };

  return (
    <div className="space-y-6">
      <CabecalhoPagina
        titulo="Haras"
        meta={<span>Escolha o haras de trabalho. O plantel e as visitas mostram só o haras escolhido.</span>}
        acoes={
          equipe && (
            <BotaoLink variante="principal" to="/haras/novo">
              Novo haras
            </BotaoLink>
          )
        }
      />
      <Aguardar consulta={consulta}>
        {({ haras, animais, avaliacoes, atual }) =>
          haras.length === 0 ? (
            <EstadoVazio
              titulo="Nenhum haras cadastrado"
              acao={
                equipe && (
                  <BotaoLink variante="principal" to="/haras/novo">
                    Cadastrar o primeiro haras
                  </BotaoLink>
                )
              }
            >
              Comece pelo haras: depois vêm os animais e o planejamento da visita.
            </EstadoVazio>
          ) : (
            <div className="overflow-hidden rounded-(--radius-painel) border border-borda bg-superficie">
              <Tabela rotulo="Haras">
                <thead>
                  <tr>
                    <th scope="col" className={classeTh}>
                      Haras
                    </th>
                    <th scope="col" className={`${classeTh} hidden sm:table-cell`}>
                      Cidade
                    </th>
                    <th scope="col" className={`${classeTh} text-right`}>
                      Animais
                    </th>
                    <th scope="col" className={`${classeTh} hidden text-right md:table-cell`}>
                      Última visita
                    </th>
                    <th scope="col" className={`${classeTh} hidden md:table-cell`}>
                      Dados
                    </th>
                    <th scope="col" className={classeTh}>
                      <span className="sr-only">Ações</span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {haras
                    .sort((a, b) => a.name.localeCompare(b.name, 'pt-BR'))
                    .map((h) => {
                      const doHaras = new Set(animais.filter((a) => a.owner_farm_id === h.id).map((a) => a.id));
                      const ultima = avaliacoes
                        .filter((a) => doHaras.has(a.animal_id))
                        .map((a) => a.visit_date)
                        .sort()
                        .at(-1);
                      const ehAtual = atual?.id === h.id;
                      return (
                        <tr
                          key={h.id}
                          onClick={() => escolher(h.id)}
                          className={`cursor-pointer transition-colors hover:bg-destaque-fundo/60 ${ehAtual ? 'bg-destaque-fundo/40' : ''}`}
                        >
                          <td className={classeTd}>
                            <button
                              type="button"
                              onClick={(e) => {
                                e.stopPropagation();
                                escolher(h.id);
                              }}
                              className="min-h-0 text-left font-serif text-[15px] font-semibold text-marca hover:underline"
                            >
                              {h.name}
                            </button>
                            {ehAtual && (
                              <span className="ml-2 align-middle">
                                <Etiqueta tom="destaque">Atual</Etiqueta>
                              </span>
                            )}
                          </td>
                          <td className={`${classeTd} hidden text-apagado sm:table-cell`}>
                            {h.city ? `${h.city}${h.uf ? `/${h.uf}` : ''}` : '—'}
                          </td>
                          <td className={`${classeTd} numero text-right`}>{doHaras.size}</td>
                          <td className={`${classeTd} numero hidden text-right text-apagado md:table-cell`}>
                            {ultima ? formatarData(ultima) : '—'}
                          </td>
                          <td className={`${classeTd} hidden md:table-cell`}>
                            <Etiqueta>{ROTULO_COMPARTILHAMENTO[h.data_sharing_level]}</Etiqueta>
                          </td>
                          <td className={`${classeTd} text-right`}>
                            {equipe && (
                              <BotaoLink tamanho="sm" variante="discreto" to={`/haras/${h.id}/editar`} onClick={(e) => e.stopPropagation()}>
                                Editar
                              </BotaoLink>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Tabela>
            </div>
          )
        }
      </Aguardar>
    </div>
  );
}
